/* Fase E1 — resolución de tenant por hostname (dominios personalizados).
   Si la app se sirve bajo un dominio que NO es de AOS/preview, el bootstrap
   resuelve a qué organizador pertenece (GET /api/public/domains/resolve) y
   las rutas públicas del organizador viven en la raíz de ese dominio.
   La URL interna AOS sigue funcionando SIEMPRE como fallback. */
import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

const AOS_HOST_SUFFIXES = [
  "aosequestrian.com",
  "emergentagent.com",
  "emergentcf.cloud",
  "emergent.host",
  "localhost",
  "127.0.0.1",
];

export const isCustomHost = (hostname = window.location.hostname) => {
  const h = (hostname || "").toLowerCase();
  return !AOS_HOST_SUFFIXES.some((s) => h === s || h === `www.${s}` || h.endsWith(`.${s}`));
};

// estado a nivel de módulo para helpers no-React (eventBase, seo)
let hostTenant = null;
export const setHostTenant = (t) => {
  hostTenant = t;
};
export const getHostTenant = () => hostTenant;

export const HostTenantContext = createContext(null);
export const useHostTenant = () => useContext(HostTenantContext);

/* orgSlug efectivo: el de la URL (rutas AOS) o el del tenant del dominio. */
export const useOrgSlug = () => {
  const { orgSlug } = useParams();
  const tenant = useHostTenant();
  return orgSlug || tenant?.slug || null;
};
